import base from './base.repository'

export default {
    ...base,
    getContacts(filters, page) {
        const params = { ...filters, page: page }
        this.get(`contacts${this.querify(params)}`)
        return this
    },
    getContactInfoConf() {
        this.get('contacts/info-conf/type')
        return this
    },
    saveContact(contact) {
        this.post(`contacts`, contact)
        return this
    },
    saveInfoData(answers) {
        this.post(`contacts/info-data`, answers)
        return this
    },
    updateContact(contact, id) {
        this.put('contacts/' + id, contact)
        return this
    },
    deleteContact(id) {
        this.delete('contacts/' + id)
        return this
    },
    // contact-report
    getReports(filters, page) {
        const params = { ...filters, page: page }
        this.get(`contacts/reports${this.querify(params)}`)
        return this
    },
    getAuthorsOfContactReports() {
        this.get(`contacts/reports/authors`)
        return this
    },
    deleteContactReport(id) {
        this.delete('contacts/reports/' + id)
        return this
    },
    saveContactReport(report) {
        this.post(`contacts/reports`, report)
        return this
    },
    updateContactReport(report, id) {
        this.put('contacts/reports/' + id, report)
        return this
    },
    saveContactReportPhotos(photos) {
        this.post(`contacts/reports/save-photos`, photos)
        return this
    },
    assignWatchers(payload) {
        this.post('contacts/reports/assign-watchers', payload)
        return this
    },
    finishReport(report, id) {
        this.post(`meetings/${id}/finish-meeting`, report)
        return this
    },
}
